import React, { useCallback } from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { clearResults, updatePortfolioQuestion, PortfolioQuestion, PortfolioAnalysisPage, getPortfolioAnalyticsTemplateUsed, getPortfolioAnalyticsTemplateUsedHasUpdated, PortfolioAnalysisTemplateRequest, setSurveyIndex } from '../store';
import styles from '../PortfolioAnalytics.module.scss';
import { Button } from '../../../shared/button/Button';

interface PortfolioAnalyticsResultsButtonsProps {
    restartSurvey: () => void;
    backToTemplates: () => void;
    portfolioQuestion: PortfolioQuestion;
    changePageView: (view: PortfolioAnalysisPage) => void;
    setSaveTemplateRequest: (template: PortfolioAnalysisTemplateRequest | null) => void;
}

export const PortfolioAnalyticsResultsButtons: React.FC<PortfolioAnalyticsResultsButtonsProps> = ({ restartSurvey, portfolioQuestion, changePageView, setSaveTemplateRequest, backToTemplates }) => {

    const dispatch = useAppDispatch();

    const templateUsed = useAppSelector(getPortfolioAnalyticsTemplateUsed);
    const templateUpdated = useAppSelector(getPortfolioAnalyticsTemplateUsedHasUpdated);

    const askAnotherQuestion = useCallback(() => {
        dispatch(updatePortfolioQuestion('question', ''));
        dispatch(clearResults());
        dispatch(setSurveyIndex(2));
        changePageView(PortfolioAnalysisPage.SURVEY);
    }, [dispatch, changePageView]);

    const saveAsTemplate = useCallback(() => {
        const request = { templateName: '', metaData: portfolioQuestion };
        setSaveTemplateRequest(request);
    }, [portfolioQuestion, setSaveTemplateRequest]);

    const saveAsNewTemplate = useCallback(() => {
        const request = { templateName: templateUsed!.templateName, metaData: portfolioQuestion };
        setSaveTemplateRequest(request);
    }, [portfolioQuestion, templateUsed, setSaveTemplateRequest]);

    const overrideTemplate = useCallback(() => {
        const request = { portfolioAnalysisTemplateId: templateUsed!.portfolioAnalysisTemplateId, templateName: templateUsed!.templateName, metaData: portfolioQuestion };
        setSaveTemplateRequest(request);
    }, [portfolioQuestion, templateUsed, setSaveTemplateRequest]);

    return (
        <div className={styles.resultsButtonWrapper}>
            <div className={styles.splitButtonsWrapper}>
                {!isNull(templateUsed) && <Button label='Back to Templates' onClick={backToTemplates} />}
                <Button label='Restart Survey' onClick={restartSurvey} />
                <Button label='Ask Another Question' onClick={askAnotherQuestion} width='fit-content' />
            </div>
            <div className={styles.splitButtonsWrapper}>
                {isNull(templateUsed) && <Button label='Save As Template' onClick={saveAsTemplate} />}
                {!isNull(templateUsed) && templateUpdated && <Button label='Save As New Template' onClick={saveAsNewTemplate} width='fit-content' />}
                {!isNull(templateUsed) && templateUpdated && <Button label='Override Template' onClick={overrideTemplate} />}
            </div>
        </div>
    );
};
